
/* injects from baggage-loader */
require('./user-select-modal.component.html');

import angular from 'angular';

angular.module('AaApp.Opp').component('userSelectModal', {
    templateUrl: '/app/components/deal-sheet/modals/user-select-modal.component.html',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});
